module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('ul', [_vm._l((_vm.taskTask), function(item, i) {
    return [_c('li', {
      staticClass: "item"
    }, [_c('div', [(item.createTime.split(' ')[0] != (i - 1 < 0 ? '' : (_vm.taskTask[i - 1].createTime.split(' ')[0]))) ? _c('div', {
      staticClass: "time"
    }, [(item.createTime.split(' ')[0] == new Date().toJSON().split('T')[0]) ? [_vm._v("今天")] : [_vm._v(_vm._s(item.createTime.split(' ')[0]))]], 2) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-block"
    }, [_c('div', [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "#4c83e3"
      },
      attrs: {
        "href": item.downloadUrl
      }
    }, [_vm._v("下载")])])]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "font-size": "13px",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.fileName) + "  " + _vm._s(item.createTime))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "cursor": "pointer",
        "min-height": "25px"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "black"
      },
      attrs: {
        "href": item.downloadUrl
      }
    }, [_vm._v("  " + _vm._s(item.downloadUrl))])]), _vm._v(" "), (item.process == 2) ? _c('div', {
      staticStyle: {
        "color": "grey"
      }
    }, [_vm._v("任务已完成")]) : _vm._e(), _vm._v(" "), (item.process == 1) ? _c('div', [_vm._v("任务进行中")]) : _vm._e()])])])])]
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warning-tips-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "infoicon"
  }), _vm._v("温馨提示\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "result"
  }, [_c('div', [_vm._v("·文件生成完成后，需手动刷新确认完成后才能下载")]), _vm._v(" "), _c('div', [_vm._v("·导出任务保留最近3天时间(包含当天)，超过3天的导出记录自动删除")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/img/excel.png"),
      "alt": "",
      "srcset": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c04e267","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DownloadList.vue
// module id = 530
// module chunks = 1